/**
 * Selects the modal.
 * @returns {Selector}
 */
export const getCurrentModalSelect = state => state.modal.current

/**
 * Selects the modal's data.
 * @returns {Selector}
 */
export const getDataModalSelect = state => state.modal.data
